module.exports = __webpack_public_path__ + "media/pricing/Mosaics-a8d8e5e2.png";